import {
    Breadcrumbs,
    Divider,
    Link,
		Stack
} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Typography from "@mui/material/Typography";
import {
    ADD_NEW_USER,
    USER_MANAGEMENT_DASHBOARD,
} from "../../../constants/messages.tsx";
import './UserForm.scss';
import { ColorBaseCharcoal } from '@huntington/honeycomb-design';
import UserManagementForm, { type UserForm } from './UserManagementForm.tsx';

const initialUserForm: UserForm = {
		userType: 'external',
		firstName: '',
		lastName: '',
		phoneType: '',
		phoneNumber: '',
		emailAddress: '',
		externalUserAccounts: [{
			roleId: {label: '', value: ''},
			accountId: {label: '', value: ''},
		}]
	}


function AddUser() {

	const navigate = useNavigate();

	const triggerNavigation = (payload: UserForm) => {
		navigate('/user-management/confirm-user', {
			state: {
				mode: 'add',
				formState: {
					...payload,
					externalUserAccounts: payload.externalUserAccounts.map(account => ({
						accountId: account.accountId.value,
						accountLabel: account.accountId.label,
						roleId: account.roleId.value,
						roleLabel: account.roleId.label,
					}))
				}
			}
		});
	}

	return (
		<Stack spacing={3}>
			<Breadcrumbs aria-label="breadcrumb">
				<Link
					underline="always"
					color="inherit"
					onClick={() => navigate('/user-management')}
					sx={{cursor: 'pointer'}}
				>
					{USER_MANAGEMENT_DASHBOARD}
				</Link>
				<Typography sx={{color: 'text.primary', fontWeight: 'bold'}}>{ADD_NEW_USER}</Typography>
			</Breadcrumbs>
			<Typography
				variant="h1"
				component="h1"
				sx={{
					color: (theme) => theme.palette.brand.primary,
					fontWeight: 'bold',
					pl: '10px',
				}}
			>
				{USER_MANAGEMENT_DASHBOARD}
			</Typography>
			<Typography
				variant="subtitle1"
				component="h2"
				sx={{
					color: ColorBaseCharcoal,
					fontWeight: 'bold',
					pl: '10px',
				}}
			>
				{ADD_NEW_USER}
			</Typography>
			<Divider/>
			<UserManagementForm userForm={initialUserForm} triggerNavigation={triggerNavigation}/>
		</Stack>
	);

}

export default AddUser;